module.exports = __webpack_public_path__ + "img/duty1.f418308b.jpg";